import { AuthService } from '../../../auth/auth.service';
import { CompanyInfo } from '../../../buyer/invoice-operation/invoice-operation-services/invoice-operation.interface';
import {
  CompanyDropdownInfo,
  MultiBuyerCmp,
} from '../../interfaces/company.interface';
import { MultiBuyerSession } from './multi-buyer-session';
import { MultiBuyerStateService } from './multi-buyer-state.service';

export class MultiBuyerIdentity {
  constructor(
    private readonly _auth: AuthService,
    private readonly _multiBuyerState: MultiBuyerStateService
  ) {}

  async fetchBuyersIds(
    multiBuyerSession: MultiBuyerSession
  ): Promise<number[]> {
    if (!this._auth.isLoggedInAsMultiBuyer()) {
      return [];
    }
    const result = await multiBuyerSession
      .buyers(this._originId, this.defaultSelectionId)
      .then((companies) => this._toCompanyDropdownInfo(companies));
    return new BuyerCollection(result).ids;
  }

  private get _originId(): number {
    const value =
      this._multiBuyerState.selectedMultiBuyerCompany?.parentCompany ??
      this._auth.userCompanyId;
    if (value === undefined) {
      throw new Error(
        'Cannot determine origin company ID: no selected multi-buyer company and no user company ID.'
      );
    }
    return value;
  }

  get defaultSelectionId(): number | undefined {
    return this._multiBuyerState.selectedMultiBuyerCompany?.id;
  }

  private _toCompanyDropdownInfo(
    companies: MultiBuyerCmp[]
  ): CompanyDropdownInfo[] {
    return companies.map(
      (company) =>
        ({ name: company.nm, id: company.id } as unknown as CompanyDropdownInfo)
    );
  }
}

export class BuyerCollection {
  constructor(private readonly _dropdownItens: CompanyDropdownInfo[] = []) {}

  dropdownItems(targetId: number): CompanyInfo[] {
    const found = this.find(targetId);
    return [found];
  }

  get ids(): number[] {
    return this._dropdownItens.map((buyer) => Number(buyer.id));
  }

  has(targetId: number): boolean {
    return this._dropdownItens.some(
      (buyer) => Number(buyer.id) === Number(targetId)
    );
  }

  get hasItems(): boolean {
    return this._dropdownItens && this._dropdownItens.length > 0;
  }

  find(targetId: number): CompanyDropdownInfo {
    const found = this._dropdownItens.find(
      (buyer) => Number(buyer.id) === Number(targetId)
    );
    if (!found) {
      throw new Error(`Company: ${targetId} not found`);
    }
    return found;
  }
}
